import React from 'react';

import type { Section } from '../../../../../models';
import { WATER_SEWER } from '../../../../../constants';
import UtilitiesOwnRentalPropertyAnnualCosts from './UtilitiesOwnRentalPropertyAnnualCosts';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function WaterSewerOwnRentalPropertyAnnualCosts({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesOwnRentalPropertyAnnualCosts
      section={section}
      setSectionValues={setSectionValues}
      annualCostsField={WATER_SEWER.FIELD_NAME.ANNUAL_COSTS}
      utilityName="Electricity"
      utilityOwnRentalPropertyYesField={WATER_SEWER.FIELD_NAME.OWN_PROPERTY_YES}
      utilityOwnRentalPropertyNoField={WATER_SEWER.FIELD_NAME.OWN_PROPERTY_NO}
      knowAnnualCostsSimilarRentalUnitField={WATER_SEWER.FIELD_NAME.KNOW_ANNUAL_COSTS_SIMILAR_RENTAL_UNIT}
    />
  );
}

export default WaterSewerOwnRentalPropertyAnnualCosts;
